/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Vibebids_VisitorsInputs */

const en_directory_vibebids_visitors = /** @type {(inputs: Directory_Vibebids_VisitorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} visitors since launch`)
};

const zh_directory_vibebids_visitors = /** @type {(inputs: Directory_Vibebids_VisitorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`上线以来 ${i?.count} 位访客`)
};

/**
* | output |
* | --- |
* | "{count} visitors since launch" |
*
* @param {Directory_Vibebids_VisitorsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_visitors = /** @type {((inputs: Directory_Vibebids_VisitorsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_VisitorsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_visitors(inputs)
	return zh_directory_vibebids_visitors(inputs)
});
export { directory_vibebids_visitors as "directory.vibebids.visitors" }